import { render, staticRenderFns } from "./TitleComponent.vue?vue&type=template&id=3c9cba9a&scoped=true&"
import script from "./TitleComponent.vue?vue&type=script&lang=js&"
export * from "./TitleComponent.vue?vue&type=script&lang=js&"
import style0 from "./TitleComponent.vue?vue&type=style&index=0&id=3c9cba9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9cba9a",
  null
  
)

export default component.exports